import { EntityName } from '@adm/backend-entity';

import { DefaultAction, Models, UserRole } from '../../enums';

const Actions = {
  ...DefaultAction,
};

export const equipmentPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.Equipment },
    { actions: [Actions.read], subject: Models.Equipments },
  ],

  [UserRole.Operator]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.Equipment },
    { actions: [Actions.read], subject: Models.Equipments },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.Equipment },
    { actions: [Actions.read], subject: Models.Equipments },
  ],

  [UserRole.DeviceOperator]: [],

  [UserRole.OperatorReadAccess]: [
    { actions: [Actions.read], subject: Models.Equipment },
    { actions: [Actions.read], subject: Models.Equipments },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [],
};
